<template>
    <div class="switch-box">
        <el-row>
          <p style="">
            {{ data.label }}
          </p>
        </el-row>
        <el-form-item>
          <el-switch
            :disabled="disabled"
            size=""
            style="
              --el-switch-on-color: #13ce66;
              --el-switch-off-color: #ff4949;
            "
            active-text="Si"
            inactive-text="No"
            v-model="data.model"
            @change="saveDataToLocalStorage(data.model, data.name)"
          />
        </el-form-item>
      </div>
</template>

<script>
import { persistToNewProviderStorage, saveDataToLocalStorage } from '../helpers/utils.js'
export default {
  data () {
    return {
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {},
  methods: {
    persistToNewProviderStorage,
    saveDataToLocalStorage
  }
}
</script>



// WEBPACK FOOTER //
// SwitchDetraction.vue?7d3ff54c